import React, { Fragment, useState } from "react";
import Layout from "../component/common/Layout/Layout";
import Header from "../component/common/Header/Header";
import { Menu, Transition } from "@headlessui/react";
import { RiArrowDropDownLine } from "react-icons/ri";
import BarChart from "../component/common/Chart/BarChart";
import SingleAreaChart from "../component/common/Chart/SingleAreaChart";
import AreaChart from "../component/common/Chart/AreaChart";
import { Link } from "react-router-dom";
import { UseContextData } from "../context/dateContext";
import { useTranslation } from "react-i18next";
import { Cascader } from "antd";

import MultiAreaChartHC from "../component/common/Chart/MultiAreaChartHC";
import TicketsResolutionChart from "../component/common/Chart/TicketsResolutionChart";
import AlertsBySeverityChart from "../component/common/Chart/AlertsBySeverityChart";
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const Canvas = () => {
  return (
    <Layout>
      <div className="grid h-full w-full grid-cols-2 grid-rows-2 p-5 gap-5 dark:bg-[#1d1d1d] ">
        <div className="text-white col-span-1 bg-white dark:bg-[#3D3D3D] row-span-1 flex rounded-xl ">
          <TicketsResolvedCard />
        </div>
        <div className="text-white col-span-1 bg-white dark:bg-[#3D3D3D] row-span-2 flex rounded-xl  ">
          <AlertsAndTicketsForecastCard />
        </div>
        <div className="text-white col-span-1  bg-white dark:bg-[#3D3D3D] row-span-1 flex  rounded-xl ">
          <AlertsBySeverityCard />
        </div>
      </div>
    </Layout>
  );
};

export default Canvas;

const TicketsResolvedCard = () => {
  return (
    <div className="flex flex-col w-full">
      <h1 className="h1 p-5 dark:text-white ">
        Tickets Resolved and Resolution time
      </h1>
      <TicketsResolutionChart />
    </div>
  );
};
const AlertsAndTicketsForecastCard = () => {
  return (
    <div className="flex flex-col w-full">
      <h1 className="h1 p-5 dark:text-white ">
        Prediction of tickets and Alerts
      </h1>
      <Forecasting />
    </div>
  );
};
const AlertsBySeverityCard = () => {
  return (
    <div className="flex flex-col w-full h-full">
      <h1 className="h1 p-5 dark:text-white">Alerts by Severity</h1>
      <AlertsBySeverityChart />
    </div>
  );
};

const Forecasting = () => {
  const [filter, setFilter] = useState("tickets");

  const items = [
    {
      label: "ZTE",
      value: "zte",
      // icon: <UserOutlined />,
    },
    // {
    //   label: "SDMC",
    //   key: "sdmc",
    //   // icon: <UserOutlined />,
    // },
  ];

  const items2 = [
    {
      label: "Tickets",
      value: "tickets",
      // disableCheckbox: true,
      // icon: <UserOutlined />,
      children: [{ label: "All Tickets", value: "all-tickets" }],
    },

    {
      label: "Alerts",
      value: "alerts",
      // disableCheckbox: true,
      children: [
        {
          label: "Frequent Periodic",
          value: "frequent-periodics",
          // icon: <UserOutlined />,
        },
        {
          label: "Idle User",
          value: "idle-user",
          // icon: <UserOutlined />,
        },
        {
          label: "Inactive Alert",
          value: "inactive-alert",
          // icon: <UserOutlined />,
        },
        {
          label: "Latency Packet Loss",
          value: "latency-packet-loss",
          // icon: <UserOutlined />,
        },
        {
          label: "All alerts",
          value: "all-alerts",

          // icon: <UserOutlined />,
        },
      ],
    },
  ];

  const onChange = (value) => {
    if (value) {
      // Normaliza el valor del cascader
      const normalizedFilter = [
        ...new Set(value.map((item) => item[item.length - 1])),
      ];
      setFilter(normalizedFilter);
      // fetch data with new filter
    }
  };

  return (
    <div className="flex-col items-center">
      <div className="flex justify-end gap-10 mr-5">
        <Cascader options={items} defaultValue={["zte"]} />
        <Cascader
          options={items2}
          defaultValue={["tickets"]}
          onChange={onChange}
          multiple
          maxTagCount="responsive"
        />
      </div>
      <MultiAreaChartHC filter={filter} />
    </div>
  );
};
